import { dashboardWidgetsPermissionConfig } from '@/_shared';

import { Layout } from '../widget-financial-snapshot-graph-card/layout';
import { Loading as FinancialSnapshotGraphCardLoading } from '../widget-financial-snapshot-graph-card/loading';

export function CreditCardDebtLoading() {
  return (
    <Layout title={dashboardWidgetsPermissionConfig['credit_card_debt'].name}>
      <FinancialSnapshotGraphCardLoading />
    </Layout>
  );
}
